export default __webpack_public_path__ + "static/media/RobotoMono-Medium.e04fa2d8.ttf";